module.exports = __webpack_public_path__ + "img/lineaOd.a005cf39.svg";